import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../utils/api";
import PartDetailsContent from "./PartDetailsContent";
import MobileFooterSheet from "./MobileFooterSheet.jsx";

const PartDetailsWrapper = ({
  partId,
  selectedBrand,
  selectedModel,
  selectedYear,
  selectedCategory,
  onBack,
  onLogoClick,
  onCartClick,
  setCurrentView
}) => {
  
  const [part, setPart] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!partId) return;
    setLoading(true);

    axios
      .get(`${API_BASE_URL}/part/${partId}`)
      .then((res) => {
        if (res.data.status) {
          setPart(res.data.data);
        } else {
          alert("فشل في جلب بيانات القطعة");
        }
      })
      .catch((err) => {
        console.error("Failed to load part details", err);
        alert("حدث خطأ أثناء جلب بيانات القطعة");
      })
      .finally(() => setLoading(false));
  }, [partId]);

  if (loading) {
    return (
      <div className="text-center text-white mt-5" style={{minHeight:"567px"}}>
        <h3>⏳ جاري تحميل بيانات القطعة...</h3>
      </div>
    );
  }

   // Fallbacks: if selectedBrand/Model/Year are not provided, read from the loaded part
 // Prefer car data from the first item in part.cars (if available)
const car0 =
  Array.isArray(part?.cars) && part.cars.length > 0 ? part.cars[0] : null;

const brandName =
  selectedBrand?.name ??
  car0?.brand?.name ??
  part?.brand?.name ??
  "";

const modelName =
  selectedModel?.name ??
  car0?.model?.name ??
  part?.model?.name ??
  "";

const yearValue =
  selectedYear?.year ??
  car0?.year?.year ??
  part?.year?.year ??
  "";

const categoryValue =
  selectedCategory?.name ??
  car0?.car_category?.name ??
  part?.car_category?.name ??
  "";

const partQunatity = part?.quantity;

  return (
    <>
    <PartDetailsContent
      part={part}
      brandName={brandName}
      modelName={modelName}
      yearValue={yearValue}
      categoryValue={categoryValue}
      quantity = {partQunatity}
      onBack={onBack}
      onLogoClick = {onLogoClick}
      onCartClick={onCartClick}
      setCurrentView = {setCurrentView}
    />
    <div className="hero">
        <MobileFooterSheet />
      </div></>
    
  );
};

export default PartDetailsWrapper;
